/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Previous_SlideInputs */

const en_previous_slide = /** @type {(inputs: Previous_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

const fr_previous_slide = /** @type {(inputs: Previous_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositive précédente`)
};

const de_previous_slide = /** @type {(inputs: Previous_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige Folie`)
};

const it_previous_slide = /** @type {(inputs: Previous_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositiva precedente`)
};

const ru_previous_slide = /** @type {(inputs: Previous_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предыдущий слайд`)
};

const es_previous_slide = /** @type {(inputs: Previous_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diapositiva anterior`)
};

const zh_cn2_previous_slide = /** @type {(inputs: Previous_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上一张幻灯片`)
};

const ja_previous_slide = /** @type {(inputs: Previous_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のスライド`)
};

const hi_previous_slide = /** @type {(inputs: Previous_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछली स्लाइड`)
};

const pt_pt2_previous_slide = /** @type {(inputs: Previous_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide anterior`)
};

/**
* | output |
* | --- |
* | "Previous slide" |
*
* @param {Previous_SlideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const previous_slide = /** @type {((inputs?: Previous_SlideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Previous_SlideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_previous_slide(inputs)
	if (locale === "de") return de_previous_slide(inputs)
	if (locale === "it") return it_previous_slide(inputs)
	if (locale === "ru") return ru_previous_slide(inputs)
	if (locale === "es") return es_previous_slide(inputs)
	if (locale === "zh-CN") return zh_cn2_previous_slide(inputs)
	if (locale === "ja") return ja_previous_slide(inputs)
	if (locale === "hi") return hi_previous_slide(inputs)
	if (locale === "pt-PT") return pt_pt2_previous_slide(inputs)
	return en_previous_slide(inputs)
});